import { render } from "./ShopCartEmptyConfirm.vue?vue&type=template&id=154dd31c&scoped=true&bindings={\"cancel\":\"options\",\"emptyCart\":\"options\"}"
import script from "./ShopCartEmptyConfirm.vue?vue&type=script&lang=js"
export * from "./ShopCartEmptyConfirm.vue?vue&type=script&lang=js"

import "./ShopCartEmptyConfirm.vue?vue&type=style&index=0&id=154dd31c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-154dd31c"

export default script